// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"836":"6d4875b6","7584":"6d4875b6","8892":"6e8f233d"}[chunkId] + ".chunk.css";
};